export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.375 9.375c0 .344.281.625.625.625a.627.627 0 00.625-.625v-3.75h3.75A.627.627 0 0010 5a.627.627 0 00-.625-.625h-3.75V.625A.627.627 0 005 0a.627.627 0 00-.625.625v3.75H.625A.627.627 0 000 5c0 .344.281.625.625.625h3.75v3.75z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "10",
    "height": "10",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};